import React from 'react';
import styles from './GetVerifiedNotice.module.css';
import { t } from 'i18next';
import { CheckWhite, VerifyBadge } from '../../../../assets/images/icons';
import BubbleButton from '../../Buttons/BubbleButton/BubbleButton';

function GetVerifiedNotice() {
    return (
        <div className={styles.container}>
            <div className={styles.column1}>
                <h2 className={styles.heading}>{t('Get Verified, Get Noticed!')}</h2>
                <p className={styles.text}>{t('Increase your visibility and attract more job opportunities by verifying your profile today.')}</p>
                <BubbleButton
                    to="/subscriptions"
                    headerButton
                    className={styles.button}
                >{t('Verify my profile now')}</BubbleButton>
            </div>
            <div className={styles.column2}>
                <div className={styles.textWithIcon}>
                    <img src={CheckWhite} alt="check" className={styles.icon} />
                    <span>{t('Instant Verification Badge')}</span>
                </div>
                <div className={styles.textWithIcon}>
                    <img src={CheckWhite} alt="check" className={styles.icon} />
                    <span>{t('Priority in Employer Searches')}</span>
                </div>
                <div className={styles.textWithIcon}>
                    <img src={CheckWhite} alt="check" className={styles.icon} />
                    <span>{t('Exclusive Access to Premium Jobs')}</span>
                </div>
            </div>
            <div className={styles.column3}>
                <img src={VerifyBadge} alt="image" className={styles.image} />
            </div>
        </div>
    );
}

export default GetVerifiedNotice;
